import React from 'react';
import ReactDOM from 'react-dom';
import Modal from './modal';

let cmsg = {};
const div = document.createElement('div');
document.body.appendChild(div);

function calls() {
  this.toaster(cmsg);
}

function open(msg) {
  cmsg = msg;
  cmsg.tirtle = msg && msg.tirtle ? msg.tirtle : 'normal';
  cmsg.content = msg && msg.content ? msg.content : '';
  cmsg.time = msg && msg.time ? msg.time : 5000;
  ReactDOM.render(<Modal />, div, calls);
}

function mAlert(msg, callback) {
  const buttons = [];
  buttons[0] = {
    tirtle: '确定',
    type: ['primary', 'small'],
    model: 'sure'
  };
  if (typeof callback === 'function') {
    buttons[0].callbk = function () { callback(); return true; };
  } else {
    buttons[0].callbk = function () { return true; };
  }
  msg.buttons = buttons;
  open(msg, callback);
}

function mConfim(msg, callback, canselCallback) {
  const buttons = [];
  buttons[0] = {
    tirtle: '确定',
    type: ['primary', 'small'],
    model: 'sure'
  };
  buttons[1] = {
    tirtle: '取消',
    type: ['small'],
    model: 'cancle'
  };
  if (typeof callback === 'function') {
    buttons[0].callbk = function () { callback(); return true; };
    buttons[1].callbk = function () { canselCallback(); return true; };
  } else {
    buttons[0].callbk = function () { return true; };
    buttons[1].callbk = function () { return true; };
  }
  msg.buttons = buttons;
  open(msg, callback);
}

export default {
  confirm: mConfim,
  alert: mAlert
};



// WEBPACK FOOTER //
// ./src/Components/Modal/index.js